import { supabase } from "@/integrations/supabase/client";

let cached: { until: number; value: Promise<boolean> } | undefined;
/** Preview is safe before the additive migration. Only missing columns fall
 * back; auth/network failures stay visible. A reload or 60s discovers rollout. */
export function agendaHasAllDayDates(): Promise<boolean> {
  if (cached && cached.until > Date.now()) return cached.value;
  const value = (async () => {
    const { error } = await supabase.from("agenda_events").select("all_day_start, all_day_end").limit(0);
    if (!error) return true;
    if (["42703", "PGRST204"].includes(error.code) && /all_day_(start|end)/.test(error.message)) return false;
    throw error;
  })();
  cached = { until: Date.now() + 60_000, value };
  void value.catch(() => { if (cached?.value === value) cached = undefined; });
  return value;
}
